// extracted by mini-css-extract-plugin
export default {"root":"style_root__hXlDP","icon":"style_icon__+KUOY"};